module.exports = __webpack_public_path__ + "static/img/call-pass.0359ef7c.png";